import Axios from '@/assets/js/AxiosPlugin'
// 回归会员列表
export const searchMemberComeback = params => {
  return Axios.post('/api/Admin/Member/comeback', params)
}



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/MemberComeback/apis/index.js